import type { Account } from '../../pages/PRM/Accounts/accountsTypes';
import accountData from './PRMAccountsMockData.json';

export const mockAccounts: Account[] = accountData.map((account): Account => {
  const { status } = account;
  if (status !== 'Active' && status !== 'Inactive') {
    throw new Error(`Invalid mock account status for account ${account.id}: ${status}`);
  }

  return { ...account, status };
});
